import { render } from "./PeListPage.vue?vue&type=template&id=2b9be584&scoped=true"
import script from "./PeListPage.vue?vue&type=script&lang=js"
export * from "./PeListPage.vue?vue&type=script&lang=js"

import "./PeListPage.vue?vue&type=style&index=0&id=2b9be584&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9be584"]])

export default __exports__